import { render, staticRenderFns } from "./source-youtube.vue?vue&type=template&id=2696d1ec&scoped=true&"
import script from "./source-youtube.vue?vue&type=script&lang=js&"
export * from "./source-youtube.vue?vue&type=script&lang=js&"
import style0 from "./source-youtube.vue?vue&type=style&index=0&id=2696d1ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2696d1ec",
  null
  
)

export default component.exports